module.exports = __webpack_public_path__ + "img/bt.b72e8925.svg";